module.exports = __webpack_public_path__ + "img/ventilador_warning.e4e4b1ef.svg";